import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/event/styles.scss';export default {
  "event": "_event_1bup7_1",
  "element": "_element_1bup7_7",
  "icon": "_icon_1bup7_12",
  "hovered": "_hovered_1bup7_21"
};